import React from 'react';
import { useTranslation } from 'react-i18next';
import { getStoreUrl } from '../utils/storeUrls';

const CTABanner = () => {
  const { t, i18n } = useTranslation();
  const storeUrl = getStoreUrl(i18n.language);

  return (
    <section className="bg-primary py-20">
      <div className="max-w-2xl mx-auto text-center px-6">
        <h2 className="text-4xl font-bold text-white mb-4">
          {t('home.cta.title', 'Start capturing smarter notes today')}
        </h2>
        <p className="text-white/80 mb-8 text-lg">
          {t('home.cta.subtitle', 'Join thousands of users already using Notely.')}
        </p>
        <a
          href={storeUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="bg-white text-primary px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-50 shadow-lg inline-block"
        >
          {t('home.cta.button', 'Download Free')}
        </a>
        <p className="text-white/60 text-sm mt-4">
          {t('home.cta.note', 'Free to download. No credit card required.')}
        </p>
      </div>
    </section>
  );
};

export default CTABanner;
